import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface SprintDocumentItem {
  id: string;
  spaceId: string;
  title: string;
  scrumDate: string | null;
  sourceType: string | null;
  status: string;
  createdAt: string;
  creator: { id: string; name: string; avatarUrl: string | null };
}

export interface CreateSprintDocumentInput {
  scrumDate: string;
  sourceType: 'TEMPLATE' | 'BLANK';
  title: string;
  content?: unknown;
}

function base(projectId: string, sprintId: string) {
  return `/projects/${projectId}/sprints/${sprintId}/documents`;
}

export async function createSprintDocument(
  projectId: string,
  sprintId: string,
  data: CreateSprintDocumentInput,
) {
  const res = await api.post<ApiResponse<SprintDocumentItem>>(
    base(projectId, sprintId),
    data,
  );
  return res.data.data!;
}

export async function fetchSprintDocuments(
  projectId: string,
  sprintId: string,
) {
  const res = await api.get<ApiResponse<SprintDocumentItem[]>>(
    base(projectId, sprintId),
  );
  return res.data.data!;
}
